/** @jsx jsx */
/* eslint-disable no-use-before-define,no-mixed-operators */
import { jsx } from '@emotion/core'
import { sectionCss, textAlignRight } from '../style.js'
import React from 'react'
import { SelectCusip } from './select-cusip.js'
import { CusipInfo } from './cusip-info.js'
import { SelectAction } from './select-action.js'
import { Quantity } from './quantity.js'
import { ExecutionType } from './execution-type.js'
import { Price } from './price.js'
import { Yield } from './yield.js'
import { SalesCredit } from './sales-credit.js'
import { Buttons } from './buttons.js'
import { Attestation } from './attestations.js'
import { useOrderTicket, MODES } from '../use-order-ticket.js'

export const Form =  () => {

    const { action, isRfq, mode, errors, noMarketRfq, isRestricted, isChangeToRfq, isTreasuryAuction } = useOrderTicket()

    const hasFormError = Object.keys(errors).length>0
    const hasPriceYield = (!isRfq && !isRestricted) || mode === MODES.ORDER_Z

    let msg = null
    const hasMsg = (!isRestricted && noMarketRfq) || isChangeToRfq
    if (hasMsg && !isTreasuryAuction) {
        msg = action==='S' ? NO_BID_MSG
            : action==='B' ? NO_OFFER_MSG
            : action==='W' ? NO_BID_MSG
            : action==='F' ? NO_OFFER_MSG
            : null
    }

    const hasSC = !isRfq || isTreasuryAuction

    return <React.Fragment>
    <div data-name="order-ticket-form"
        className="container order-ticket-form vertical-offset-sm"
        css={sectionCss}>

        {!isTreasuryAuction && <React.Fragment>
            <div className="row vertical-offset-sm"></div>
            <SelectCusip />
            </React.Fragment>}

        <div className="row vertical-offset-sm"></div>
        <CusipInfo />

        <div className="row vertical-offset-xs"><div className="col-md-12"><hr aria-hidden={true} /></div></div>

        <div className="row">
        <div className="col-md-6 col-sm-6 col-xs-12 vertical-offset-sm">
            <SelectAction />
        </div>
        <div className="col-md-6 col-sm-6 col-xs-12 vertical-offset-sm">
            <Quantity />
        </div>
        </div>

        { (hasPriceYield || isTreasuryAuction) && <React.Fragment>
            <div className="row">
            <div className="col-md-12 col-xs-12  vertical-offset-sm">
                <ExecutionType />
            </div>
            </div>
        </React.Fragment>}

        { hasPriceYield && !isTreasuryAuction && <React.Fragment>
            <div className="row">
            <div className="col-md-12 col-xs-12 vertical-offset-sm">
                <Price />
            </div>
            </div>

            <div className="row">
            <div className="col-md-12 col-xs-12 vertical-offset-md">
                <Yield />
            </div>
            </div>
        </React.Fragment>}

        { hasFormError && <React.Fragment>
            <div className="row">
            <div className="col-md-12 col-xs-12 text-center" >
                <label className="has-error">Please fill out the required information</label>
            </div>
            </div>
        </React.Fragment>}

        {msg && <div className="row">
            <div className="col-md-12 col-xs-12">
                <div className="universal-message universal-message-warning" role="alert">
                <div className="universal-message-content">
                <div className="universal-message-heading">{msg}</div>
                </div>
                </div>
            </div>
            </div>
        }

        { isRestricted && (() => {
            const t = ['B','F'].indexOf(action)>=0 ? 'Buy orders and offer wanted quote requests'
            // : ['S','W'].indexOf(action)>=0 ? 'Sell orders and bid wanted quote requests'
            : 'Orders and quote requests'

            const msg = `${t} for this asset class are not available for online trading.
                Please call our Fixed Income Specialists at 877-355-3237 with inquiries or for support placing orders.`

            return <React.Fragment>
                <div className="row">
                <div className="col-md-12 col-xs-12">
                    <div className="universal-message universal-message-warning" role="alert">
                    <div className="universal-message-content">
                    <div className="universal-message-heading">{msg}</div>
                    </div>
                    </div>
                </div>
                </div>
                </React.Fragment>
        })() }


        { hasPriceYield && <Attestation /> }

        { (hasPriceYield || hasFormError || isTreasuryAuction )
        && <div className="row vertical-offset-sm"><div className="col-md-12"><hr aria-hidden={true} /></div></div> }

        <div className="row">
            {hasSC &&
                <div className="col-md-7 col-xs-12 vertical-offset-sm" style={{display:'flex'}}>
                    <SalesCredit />
                </div>}

            <div className={`${!hasSC ? "" : "col-md-5"} col-xs-12 text-center vertical-offset-sm`} css={textAlignRight}>
            <Buttons />
            </div>
        </div>

        <div className="row vertical-offset-sm"></div>
    </div>
    </React.Fragment>
}

const NO_BID_MSG = "There is no bid for this quantity. Please click ‘Preview Order’ to submit this order as a bid wanted quote request."

const NO_OFFER_MSG = "There is no offer for this quantity. Please click ‘Preview Order’ to submit this order as an offer wanted quote request."
